import { RazorInputField } from "../../../../components/razor-reuse";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../../components/fragment/modal/ReuseModal";
import RootState from "../../../../redux/type";
import {
  createRemittanceRule,
  getRemittanceRules,
} from "../../../../redux/featureMgt";

interface myComponentProps {
  onClose?: () => void;
  visible?: boolean;
  onComplete?: () => void;
}

type formProp = {
  min_spend: string;
  max_spend: string;
  smartsend_remit: string;
};

const CreateThresholdModal = ({
  onClose,
  visible,
  onComplete,
}: myComponentProps) => {
  const dispatch = useDispatch();
  const { mutating } = useSelector((state: RootState) => state.feature_mgt);

  const [details, setDetails] = useState<formProp>({
    min_spend: "",
    max_spend: "",
    smartsend_remit: "",
  });

  const handleSubmit = async () => {
    const payload = { ...details, smartsend_without_value: true };
    const data = await dispatch(createRemittanceRule(payload) as any);

    if (data?.payload?.data?.status) {
      setDetails({
        min_spend: "",
        max_spend: "",
        smartsend_remit: "",
      });
      dispatch(getRemittanceRules({ page: 1 }) as any);
      onComplete?.();
    }
  };

  const handleClose = () => {
    setDetails({
      min_spend: "",
      max_spend: "",
      smartsend_remit: "",
    });
    onClose?.();
  };

  return (
    <>
      <ReuseModal
        title="Remittance Threshold"
        btnLabel="Save"
        visible={visible}
        onClose={handleClose}
        disable={
          !details.min_spend ||
          !details.smartsend_remit ||
          !details.max_spend ||
          mutating
        }
        loading={mutating}
        onBtnClick={handleSubmit}
      >
        <div className="add-exchange-currency-modal-wraps space-y-[20px]">
          <>
            <RazorInputField
              value={details?.min_spend}
              color="black-light"
              label="Minimum Limit ($)"
              type={`number`}
              placeholder="Enter Amount e.g(1,000)"
              onChange={(e: any) => {
                const val = e.target.value;
                if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0))
                  setDetails((prev) => ({ ...prev, min_spend: val }));
              }}
              // thousandFormat
              min={0}
            />
            <RazorInputField
              value={details?.max_spend}
              color="black-light"
              label="Maximum Limit ($)"
              type={`number`}
              placeholder="Enter Amount e.g(1,000)"
              onChange={(e: any) => {
                const val = e.target.value;
                if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0))
                  setDetails((prev) => ({ ...prev, max_spend: val }));
              }}
              // thousandFormat
            />
            <RazorInputField
              value={details?.smartsend_remit}
              color="black-light"
              label="Highest Transaction Threshold ($)"
              type={`number`}
              placeholder="Enter Amount e.g(1,000)"
              onChange={(e: any) => {
                const val = e.target.value;
                if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0))
                  setDetails((prev) => ({ ...prev, smartsend_remit: val }));
              }}
              // thousandFormat
            />
          </>
        </div>
      </ReuseModal>
    </>
  );
};

export default CreateThresholdModal;
